import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'clsx';
import Icons from '../../constants/Icons';
import { AppQueryParams, AppSections } from '../../constants';
import { getBillingOptions } from '../hooks';

const ProductDetailsAction = ({
  productDetails,
  isUserVip,
  handleRedeem,
  productId,
  handleBuy,
  userToken,
  isWeb,
  isMobile,
  isLiveRoomsSection,
}) => {
  const { t } = useTranslation();

  const { isRedeemable, isPurchasable } = useMemo(
    () => getBillingOptions(productDetails),
    [productDetails],
  );

  const originPath = window.location.origin;

  const unauthorizedUrl = `${originPath}/shop/dev/orders?navigation=authentication`;

  const redeemUrlQuery = useMemo(() => {
    const queryParams = new URLSearchParams({
      productId: `${productId}`,
    });

    if (isLiveRoomsSection) {
      queryParams.set(AppQueryParams.AppSection, AppSections.LiveRoom);
      queryParams.set(AppQueryParams.OngoingTransaction, 'true');
      queryParams.set(AppQueryParams.DismissShop, 'false');
    }

    return `&${queryParams.toString()}`;
  }, [productId, isLiveRoomsSection]);

  const purchaseUrlQuery = useMemo(() => {
    const queryParams = new URLSearchParams({
      productId: `${productId}`,
    });

    if (isLiveRoomsSection) {
      queryParams.set(AppQueryParams.AppSection, AppSections.LiveRoom);
    }

    return `&${queryParams.toString()}`;
  }, [productId, isLiveRoomsSection]);

  const actionsClassName = classNames('product-details-actions-div', {
    'mobile-actions': !isWeb,
  });

  return (
    <div className={actionsClassName}>
      {isRedeemable && isPurchasable ? (
        <>
          <div style={{ color: 'white' }} className="pos-rel">
            {isUserVip && (
              <img src={Icons.vipDiscountSm} alt="VIP" className="vip-product vip-product-sm" />
            )}
            <a
              onClick={handleBuy}
              style={
                !isPurchasable || !productDetails.stock
                  ? { pointerEvents: 'none', opacity: '0.5' }
                  : null
              }
              className={`confirm-btn ${!isWeb ? 'confirm-btn-mobile' : ''}`}
              href={
                !userToken && !isWeb
                  ? unauthorizedUrl
                  : `/shop/products/${productId}/buy?payment=card${purchaseUrlQuery}`
              }
            >
              {t('buy_now')}
            </a>
          </div>
          {!isWeb && (
            <div style={{ color: '#00AAFF' }} className="pos-rel">
              <a
                href={
                  !userToken
                    ? unauthorizedUrl
                    : `/shop/products/${productId}/buy?payment=points${redeemUrlQuery}`
                }
                className={`confirm-btn grey ${!isWeb ? 'confirm-btn-mobile' : ''}`}
                style={productDetails.stock <= 0 ? { pointerEvents: 'none', opacity: '0.5' } : null}
                onClick={handleRedeem}
              >
                {t('redeem_with_points')}
              </a>
            </div>
          )}
        </>
      ) : (
        <>
          {isRedeemable && !isWeb ? (
            <div style={{ color: '#00AAFF' }} className="pos-rel">
              <a
                href={
                  !userToken
                    ? unauthorizedUrl
                    : `/shop/products/${productId}/buy?payment=points${redeemUrlQuery}`
                }
                className={`confirm-btn ${!isWeb ? 'confirm-btn-mobile' : ''}`}
                onClick={handleRedeem}
                style={!productDetails.stock ? { pointerEvents: 'none', opacity: '0.5' } : null}
              >
                {t('redeem_with_points')}
              </a>
            </div>
          ) : (
            <div className="w-100">
              <div style={{ color: 'white' }} className="pos-rel">
                {isUserVip && (
                  <img src={Icons.vipDiscountLg} alt="VIP" className="vip-product vip-product-lg" />
                )}
                <a
                  onClick={handleBuy}
                  style={
                    !isPurchasable || !productDetails.stock
                      ? { pointerEvents: 'none', opacity: '0.5' }
                      : null
                  }
                  className={`confirm-btn ${!isWeb ? 'confirm-btn-mobile' : ''}`}
                  href={
                    !userToken && !isWeb
                      ? unauthorizedUrl
                      : `/shop/products/${productId}/buy?payment=card${purchaseUrlQuery}`
                  }
                >
                  {t('buy_now')}
                </a>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ProductDetailsAction;
